import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RangeElement } from './range.component';
import { createCustomElement } from '@angular/elements';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [RangeElement],
    imports: [CommonModule, IconModule, TranslocoDirective, ReactiveFormsModule, FormsModule],
    exports: [RangeElement],
})
export class RangeModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(RangeElement, {
            injector: this.injector,
        });

        customElements.define('bazis-range', el);
    }
}
